<template>
    <span v-if="displayedTime" :class="computedClass">
        <i class="fa-solid fa-clock-rotate-left"></i>
        {{ displayedTime }}
    </span>
</template>

<script>
export default {
    name: 'CqUpdate',
    props: {
        timestamp: {
            type: [Number, String],
            required: true
        },
        class: {
            type: String,
            default: ''
        }
    },

    data() {
        return {
            displayedTime: '',
            updateTimer: null,
            cssClass: 'timecq',
            isHours: false
        }
    },

    computed: {
        timestampValue() {
            return typeof this.timestamp === 'string'
                ? parseInt(this.timestamp)
                : this.timestamp;
        },

        computedClass() {
            let classes = [this.cssClass];
            if (this.isHours) {
                classes.push('timeHeures');
            }
            if (this.class) {
                classes.push(this.class);
            }
            return classes.join(' ');
        }
    },

    mounted() {
        this.updateTime();
        this.updateTimer = setInterval(() => {
            this.updateTime();
        }, 60000);
    },

    methods: {
        updateTime() {
            const now = Math.floor(Date.now() / 1000);
            const seconds = now - this.timestampValue;
            const minutes = Math.floor(seconds / 60);
            const hours = Math.floor(minutes / 60);

            this.isHours = false;

            if (minutes < 60) {
                if (minutes === 0) {
                    this.displayedTime = `Mis à jour il y a ${seconds} secondes`;
                } else if (minutes === 1) {
                    this.displayedTime = `Mis à jour il y a ${minutes} minute`;
                } else {
                    this.displayedTime = `Mis à jour il y a ${minutes} minutes`;
                }
            } else if (hours === 1) {
                this.displayedTime = `Mis à jour il y a ${hours} heure`;
                this.isHours = true;
            } else if (hours < 2) {
                this.displayedTime = `Mis à jour il y a ${hours} heures`;
                this.isHours = true;
            } else {
                this.displayedTime = '';
            }
        }
    },

    beforeUnmount() {
        if (this.updateTimer) {
            clearInterval(this.updateTimer);
        }
    }
}
</script>

<style scoped>
    .timecq {
        color: var(--color-primary);
        font-size: 10px;
        font-weight: 500;
        line-height: 24px;
        padding-top: 5px;display: inline-block;
        text-transform: uppercase;
        &.timeHeures {
            color: #555;
        }
    }
</style>
